import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// Aiming to make this file easily expandable. potentially breaking out default animations into their own classes (for enqueueing on blocks or globally as needed)
export default class GlobalAnimations {
  constructor() {
    this.init();
  }

  init() {
    this.elementInFromBottom();
    this.elementInFromTop();
    this.maskRevealFromBottom();
    this.maskRevealFromTop();
  }

  elementInFromBottom(mm) {
    var animations = gsap.utils.toArray(".--animate__from-bottom");

    if(animations) {
      var mm = gsap.matchMedia();

      mm.add("(max-width: 1024px)", () => {
        animations.forEach((elm) => {
          gsap.fromTo(
            elm,
            {opacity: 0, y: "40px"},
            {opacity: 1, y: 0, scrollTrigger:{
              trigger: elm,
              start: "top 80%",
              }
            })
        });
      });
      mm.add("(min-width: 1024px)", () => {
        animations.forEach((elm) => {
          gsap.fromTo(
            elm,
            {opacity: 0, y: "40px"},
            {opacity: 1, y: 0, scrollTrigger:{
              trigger: elm,
              start: "center 67%",
              }
            })
        });
      });
    }
  }

  elementInFromTop() {
    var animations = gsap.utils.toArray(".--animate__from-top");

    if(animations) {
    animations.forEach((elm) => {
      gsap.fromTo(
        elm,
        {opacity: 0, y: "-40px"},
        {opacity: 1, y: 0, scrollTrigger:{
          trigger: elm,
          start: "center 67%",
          }
        })
     });
    }
  }

  maskRevealFromBottom() {
    var animations = gsap.utils.toArray(".--animate__mask-reveal-from-bottom");

    if(animations) {
    animations.forEach((elm) => {
      gsap.fromTo(
        elm,
        {clipPath: "inset(100% 0% 0% 0%)"},
        {clipPath: "inset(0% 0% 0% 0%)", duration: 1, ease: "power1.in", scrollTrigger:{
          trigger: elm,
          start: "center 67%",
          }
        })
     });
    }
  }

  maskRevealFromTop() {
    var animations = gsap.utils.toArray(".--animate__mask-reveal-from-top");

    if(animations) {
    animations.forEach((elm) => {
      gsap.fromTo(
        elm,
        {clipPath: "inset(0% 0% 100% 0%)"},
        {clipPath: "inset(0% 0% 0% 0%)", duration: 1, ease: "power1.in", scrollTrigger:{
          trigger: elm,
          start: "center 67%",
          }
        })
     });
    }
  }
}
